import { render, staticRenderFns } from "./MyFederations.vue?vue&type=template&id=15af2c57&"
import script from "./MyFederations.vue?vue&type=script&lang=js&"
export * from "./MyFederations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports